import React, { useEffect, useState } from "react";
import { Redirect } from "react-router";

import RoomService from "../../../service/rooms-service";
import View from "./view";
import Loading from "../../views/loading";
import Error from "../../views/error";

const STATUS = { LOADING: 1, ERROR: 2, SUCCESS: 3 };

export default () => {
  const [status, setStatus] = useState(STATUS.LOADING);
  const [redirect, setRedirect] = useState(null);
  const [rooms, setRooms] = useState(null);

  const fetchRooms = async () => {
    setStatus(STATUS.LOADING);
    const rooms = await RoomService.fetchAllRooms();
    if (rooms) {
      setRooms(rooms);
      setStatus(STATUS.SUCCESS);
    } else {
      setStatus(STATUS.ERROR);
    }
  };

  useEffect(() => {
    fetchRooms();
  }, []);

  if (redirect) return <Redirect push to={`/room/${redirect}`} />;

  switch (status) {
    case STATUS.LOADING:
      return <Loading />;
    case STATUS.SUCCESS:
      if (rooms.length == 0)
        return (
          <Error message="You have not joined any room. Join or create one through navigation!" />
        );
      else return <View rooms={rooms || []} />;
    case STATUS.ERROR:
      return (
        <Error message="You have not joined any room. Join or create one through navigation!" />
      );
    default:
      return (
        <Error message="You have not joined any room. Join or create one through navigation!" />
      );
  }
};
